import { Box, FormControl, MenuItem, Select } from '@material-ui/core';
import { getLoanById, OnboardingDetailsRole } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { useParams } from 'react-router';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useParticipantSourceStyles } from '@/components/widgets/ParticipantSourceWidget/_shared/hooks/useParticipantSourceStyles';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { findCurrentParticipantOnboardingDetailsByOnboardingDetailsId } from '@/utils/findCurrentParticipantOnboardingDetails';

export const LoanParticipantSourceWidget = () => {
  const { loanId } = useParams();
  if (!loanId) return null;

  const { data: loan } = useCache(getLoanById, { loanId });

  const disabled = loan?.onboardingDetails && loan.onboardingDetails.length <= 1;

  const {
    state: { applicationParticipant, loading },
    actions: pageActions,
  } = usePageContext();
  const { classes } = useParticipantSourceStyles({ disabled: !!disabled, loading });

  const onboardingDetails = loan?.onboardingDetails;

  useEffect(() => {
    if (loan && onboardingDetails) {
      const currentBorrowerOnboardingDetails = onboardingDetails.find(
        (details) => details.role === OnboardingDetailsRole.BORROWER,
      );
      pageActions.setApplicationParticipant({
        role: OnboardingDetailsRole.BORROWER,
        onboardingDetails: currentBorrowerOnboardingDetails,
      });
      return () => {
        pageActions.setApplicationParticipant({
          role: OnboardingDetailsRole.BORROWER,
          onboardingDetails: currentBorrowerOnboardingDetails,
        });
      };
    }
  }, [loan]);

  const handleChange = (e) => {
    const currentParticipant = findCurrentParticipantOnboardingDetailsByOnboardingDetailsId({
      loan: loan,
      onboardingDetailsId: e.target.value,
    });
    if (!currentParticipant) return;
    pageActions.setApplicationParticipant({ role: currentParticipant.role, onboardingDetails: currentParticipant });
  };

  return applicationParticipant.onboardingDetails ? (
    <div>
      <FormControl className={classes.root} variant="filled" style={{ width: '208px' }}>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={applicationParticipant.onboardingDetails.id}
          onChange={handleChange}
          disabled={disabled}
        >
          {onboardingDetails?.map((participantDetails) => (
            <MenuItem value={participantDetails.id} key={participantDetails.id}>
              {!loading && (
                <Box display={'flex'} flexDirection={'column'}>
                  <Font variant={'overline'} color={'title'}>
                    <Text tId={participantDetails.role} />
                  </Font>
                  <Font variant={'h5'} color={'title'}>
                    {`${participantDetails?.invitation?.fullName.firstName} ${participantDetails?.invitation?.fullName.lastName}`}
                  </Font>
                </Box>
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  ) : (
    <></>
  );
};
